<article
  class="limit-card"
  [class.limit-card--unlimited]="state === 'unlimited'"
  [class.limit-card--unavailable]="state === 'unavailable'"
  [class.limit-card--blocking]="state === 'blocking'"
  [class.limit-card--overage]="state === 'overage_allowed'"
  [class.limit-card--warning]="state === 'warning'"
  [class.limit-card--healthy]="state === 'healthy'">

  <header class="limit-card__header">
    <h3 class="limit-card__title">{{ limit.limitCode | limitLabel }}</h3>
    <app-usage-data-quality-pill [flags]="limit.dataQuality"></app-usage-data-quality-pill>
  </header>

  <div class="limit-card__meta">
    <span class="limit-card__values">
      <strong class="limit-card__consumed">{{ consumedDisplay }}</strong>
      <span class="limit-card__sep" aria-hidden="true">/</span>
      <span class="limit-card__total">{{ limitValueDisplay }}</span>
      <span class="limit-card__unit" *ngIf="unitLabel">{{ unitLabel }}</span>
    </span>
    <span class="limit-card__percent" *ngIf="displayPercent !== null">
      {{ displayPercent | number:'1.0-0' }}%
    </span>
  </div>

  <progress
    *ngIf="displayPercent !== null"
    class="limit-card__progress"
    [value]="progressWidth"
    max="100"
    [attr.aria-label]="(limit.limitCode | limitLabel) + ' ' + (displayPercent | number:'1.0-0') + '%'">
    {{ displayPercent | number:'1.0-0' }}%
  </progress>

  <footer class="limit-card__footer">
    <span class="limit-card__enforcement">{{ enforcementLabel }}</span>
    <span class="limit-card__status" *ngIf="state === 'blocking'">
      {{ 'usage.over_limit_blocking' | translate }}
    </span>
    <span class="limit-card__status limit-card__status--overage" *ngIf="state === 'overage_allowed'">
      {{ 'usage.over_limit_allowed' | translate }}
    </span>
    <span class="limit-card__status" *ngIf="state === 'unlimited'">
      {{ 'usage.unlimited' | translate }}
    </span>
  </footer>
</article>
